import { render, staticRenderFns } from "./RequestStatusLabel.vue?vue&type=template&id=56f904d8"
import script from "./RequestStatusLabel.vue?vue&type=script&lang=js"
export * from "./RequestStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports